import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { getImageRedirectUrl, getImageStatusUrl } from '../../../../../../../helper/common'
import { base64toBlob, downloadFileImmediate, saveBlob } from '../../../../../../../helper/download.helper'

declare var imageControl

@Component({
    selector: 'app-modal-client-detail-registration-dsd',
    templateUrl: './modal-client-detail-registration-dsd.component.html',
    styleUrls: [
        '../../../../../../stagingcss/canvas.component.css',
        './modal-client-detail-registration-dsd.component.css',
    ],
})
export class ModalClientDetailRegistrationDsdComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() canvasType: string
    @ViewChild('modalLoading') modalLoading: ElementRef
    @ViewChild('modalLoadingInput') modalLoadingInput: ElementRef
    @ViewChild('rangeTop') rangeTop: ElementRef
    @ViewChild('restoreBtn') restoreBtn: ElementRef
    showCanvas = false
    canvasHeight = '300px'
    canvasEg = {}
    canvasList = []
    selectDate = 0
    clientId = '12345'
    imgControl
    canvasBackup = {}
    canvasState = 'create'
    index = 0
    previousIndex = -1
    dsdCanvas = ''
    dateList = []
    registrationData = []
    showLoading = false
    changeEmittedIndex: any
    changeEmittedAllArrClientTo: any
    canvasModalLoading: any
    cancelEmittedBtn: any
    loadingStatus = ''

    sectionId = 'section-dsd'
    currentIndexData = {}
    allowDSD = false
    videoPadding = '0px'
    videoUrl = ''
    originImageUrl = ''
    originImageBase64 = ''
    showCutLoading = false

    constructor(private authData: AuthService,
                private restApi: RestServices,
                public clientTopServices: ClientTopServices) {
    }

    ngOnDestroy() {
        this.clearCanvasLocal()
        if(this.changeEmittedIndex)
            this.changeEmittedIndex.unsubscribe()
        if(this.changeEmittedAllArrClientTo)
            this.changeEmittedAllArrClientTo.unsubscribe()
        if(this.canvasModalLoading)
            this.canvasModalLoading.unsubscribe()
        if(this.cancelEmittedBtn)
            this.cancelEmittedBtn.unsubscribe()
        window['canvasChange'] = false
        window['canvasVideo'] = ''
        window['canvasVideoSave'] = ''
        if (this.currentIndexData) {
            this.currentIndexData['updateIndex'] = false
            this.clientTopServices.emitChangeIndex(this.currentIndexData)
        }
        window['uploadVideoSrc'] = ''
        window['uploadImageSrc'] = ''
        this.videoUrl = ''
        this.originImageUrl = ''
        this.originImageBase64 = ''
        this.dsdCanvas = ''
        this.registrationData = []
        if (this.imgControl && this.imgControl.canvas) {
            $(window).off('resize')
            this.imgControl.canvas.dispose()
        }
        this.imgControl = null
    }

    ngOnInit() {
        if (this.canvasType == 'smile') {
            this.sectionId = 'section-smile'
            this.removeElement('section-dsd')
        } else {
            this.sectionId = 'section-dsd'
            this.removeElement('section-smile')
        }
        if (this.canvasState == 'create') {
            this.imgControl = new imageControl('canvas-item', this.canvasType)
        }
        this.setCanvasDimension()
        this.getArrClientTop()
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setCanvasDimension()
    }

    modalLoadingVisible(visible) {
        if (visible) {
            this.modalLoading.nativeElement.show()
            this.modalLoadingInput.nativeElement.show()
        } else {
            this.modalLoading.nativeElement.hide()
            this.modalLoadingInput.nativeElement.hide()
        }
    }

    toggleCutLoading() {
        this.loadingStatus = ''
        if (!this.showCutLoading) {
            this.modalLoading.nativeElement.show()
            this.showCutLoading = true
        } else {
            this.modalLoading.nativeElement.hide()
            this.showCutLoading = false
        }
    }

    clearCanvasLocal() {

        window['canvas'] = ''
        window['canvasImgBase'] = ''
        window['canvasImgBefore'] = ''
        window['canvasImgDemo'] = ''
        window['canvasVideo'] = ''
    }

    getArrClientTop() {
        this.canvasModalLoading = this.clientTopServices.canvasModalLoading$.subscribe(loading => {
            if (loading) {
                this.loadingStatus = loading.status
                this.modalLoadingVisible(loading.show)
            }
        })
        this.dsdCanvas = ''
        this.changeEmittedIndex = this.clientTopServices.changeEmittedIndex$.subscribe((index) => {
            this.currentIndexData = index
            if ((index && this.clientTopServices.slideshowActive && index.updateIndex) || !this.clientTopServices.slideshowActive) {
                const sentArr = this.clientTopServices.getAllArrClientTop()
                if (sentArr && sentArr.length > 0) {
                    this.registrationData = sentArr
                    this.inititalClientTop({ registration: this.registrationData })
                    this.allowDSD = true
                } else {
                    this.allowDSD = false
                    this.showCanvas = false
                }
            }
            if (this.clientTopServices.slideshowActive) {
                this.clientTopServices.slideshowActive = false
            }
        })

        this.changeEmittedAllArrClientTo = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            if (res && res.checkChange == true) {
                this.inititalClientTop(res)
            } else if (res && !res.checkChange && res.registration && res.registration.length < this.registrationData.length) { // delete record
                let index = this.clientTopServices.getIndex()
                if (index >= res.registration.length) {
                    index -= 1
                    this.clientTopServices.emitChangeIndex({ index: index })
                }
            }
        })

        this.cancelEmittedBtn = this.clientTopServices.cancelEmittedBtn$.subscribe(res => {
            if (res) {
                this.index = this.clientTopServices.previousIndex
                this.previousIndex = this.clientTopServices.previousIndex
                if (this.registrationData.length > 1) {
                    this.selectDate = this.index * 100 / (this.registrationData.length - 1)
                }
            }
        })
    }

    inititalClientTop(res) {
        this.clearCanvasLocal()
        this.index = this.clientTopServices.getIndex()
        this.clientTopServices.updatePreviousIndex(this.index)
        this.showCanvas = false
        this.dsdCanvas = ''
        const video = <HTMLVideoElement>document.getElementById('canvas-video')
        video.innerHTML = ''
        video.load()
        if (res && res['registration'] && res['registration'].length > 0 && this.index != null) {
            this.registrationData = res['registration']
            this.registrationData.sort(function(a, b) {
                return a.dateStringToInit - b.dateStringToInit
            })
            if (this.registrationData.length > 1) {
                this.rangeTop.nativeElement.setAttribute('max', 100)
                this.selectDate = this.index * 100 / (this.registrationData.length - 1)
            } else {
                this.rangeTop.nativeElement.setAttribute('max', 0)
                this.selectDate = 0
            }
            if (this.canvasType == 'dsd' && this.registrationData[this.index] && this.registrationData[this.index].dsd) {
                const dsd = this.registrationData[this.index].dsd
                this.showLoading = true
                if (dsd.canvasVideo && dsd.canvasVideo != 'undefined') {
                    const urlVideo = getImageStatusUrl(this.registrationData[this.index].dsd.canvasVideo)

                    this.toVideoURL(urlVideo, (e) => {
                        //video url
                        this.videoUrl = e
                        window['canvasVideo'] = e
                        const video = <HTMLVideoElement>document.getElementById('canvas-video')
                        video.innerHTML = ''
                        var source = document.createElement('source')
                        source.setAttribute('src', e)
                        video.appendChild(source)
                        video.load()
                        this.loadRedirectData(dsd)
                    })
                } else {
                    this.loadRedirectData(dsd)
                }
            } else if (this.canvasType == 'smile' && this.registrationData[this.index] && this.registrationData[this.index].smile) {
                const smile = this.registrationData[this.index].smile
                this.showLoading = true

                if (smile.canvasImgBase && smile.canvasImgBase.indexOf('data:image') === -1) {
                    const urlImg = getImageStatusUrl(this.registrationData[this.index].smile['canvasImgBase'])

                    this.toDataURL(urlImg, 'canvasImgBase', 1, (e) => {
                        window['canvasImgBase'] = e
                        this.updateCanvas()
                    })
                } else if (smile.canvasImgBase && smile.canvasImgBase.indexOf('data:image') !== -1) {
                    window['canvasImgBase'] = smile.canvasImgBase
                    this.updateCanvas()
                }
            } else {
                this.updateCanvas()
            }
        } else {
            this.rangeTop.nativeElement.setAttribute('max', 0)
            this.selectDate = 0
            this.clientTopServices.emitChangeSlider(0)
        }
    }

    loadRedirectData(dsd) {
        let count = 1
        if (dsd.canvasImgBase) {
            for (let k in dsd) {
                if (dsd.hasOwnProperty(k) && dsd[k] && dsd[k] != 'undefined') {
                    if ((k == 'canvasImgBase' || k == 'canvasImgBefore')) {
                        if (dsd[k].indexOf('data:image') === -1) {
                            //Origin image
                            const urlImg = getImageStatusUrl(dsd[k])

                            this.originImageUrl = urlImg

                            this.toDataURL(urlImg, k, count, (e) => {
                                //check origin or edited image
                                if (k == 'canvasImgBefore')
                                    this.originImageBase64 = e

                                window[k] = e

                                if (count < 2) {
                                    count++
                                } else {
                                    this.updateCanvas()
                                }
                            })
                        } else if (dsd[k].indexOf('data:image') === 1) {
                            window[k] = dsd[k]
                            if (count == 2) {
                                this.updateCanvas()
                            } else {
                                count++
                            }
                        }
                    }
                }
            }
        } else {
            this.updateCanvas()
        }
    }

    downloadOriginImage(event, filename) {
        if (this.originImageBase64 || window['uploadImageSrc']) {
            const base64Img = window['uploadImageSrc'] || this.originImageBase64
            const imageBlob = base64toBlob(base64Img, 'image/png')
            saveBlob(imageBlob, filename)
        }
    }

    downloadVideo(event, filename) {
        if (this.videoUrl || window['uploadVideoSrc']) {
            const videoUrl = window['uploadVideoSrc'] || this.videoUrl
            downloadFileImmediate(videoUrl, filename)
        }
    }

    changeDate() {
        const dataLength = this.registrationData.length
        const unit = 100 / (this.registrationData.length - 1)
        if (this.selectDate % unit > (unit / 2)) {
            this.selectDate = this.selectDate - this.selectDate % unit + unit
        } else {
            this.selectDate = this.selectDate - this.selectDate % unit
        }
        this.index = Math.round((this.selectDate / 100) * dataLength)
        this.clientTopServices.updatePreviousIndex(this.previousIndex)
        if (this.index != this.previousIndex) {
            this.previousIndex = this.index
            const valueSlider = {
                'sliderClientTop': this.selectDate,
            }
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    updateCanvas() {
        if (this.registrationData[this.index]) {
            if (this.registrationData[this.index][this.canvasType]) {
                this.dsdCanvas = this.registrationData[this.index][this.canvasType].canvas
                window['canvas'] = this.dsdCanvas
            }
            // this.imgControl.updateCanvas();
            document.getElementById('update-canvas-btn').click()
            this.showCanvas = this.dsdCanvas && this.dsdCanvas != 'undefined'
            this.showLoading = false
        }
        // this.clearCanvasLocal();
    }

    setCanvasDimension() {
        const canvas = document.getElementById('bd-wrapper')
        const canvasHeight = Math.round(canvas.offsetWidth * 720 / 1280)
        this.canvasHeight = canvasHeight + 'px'
        this.videoPadding = canvasHeight * 0.1 + 'px'
    }

    removeElement(id) {
        const elem = document.getElementById(id)
        if (elem) {
            elem.parentNode.removeChild(elem)
        }
    }

    // show canvas if invalid file and upload video file
    uploadFile(e) {
        const fileType = e.target.files[0]['type']
        if ((this.canvasType == 'dsd' && (fileType.indexOf('image') !== -1 || fileType.indexOf('video') !== -1))
            || (this.canvasType == 'smile' && fileType.indexOf('image') !== -1)) {
            this.showCanvas = true
        }
        if (this.canvasType == 'dsd' && fileType.indexOf('video') !== -1) {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(e.target.files[0], tokenReNew).subscribe(
                    data => {
                        const url = getImageRedirectUrl(data['hash'])
                        window['canvasVideoSave'] = url
                        window['canvasVideoCopy'] = url
                    },
                )
            })
        }
    }

    onDrop(event) {
        const files = {
            target: {
                files: event.dataTransfer.files,
            },
        }
        this.uploadFile(files)
        event.preventDefault()
    }

    // get redirected image link
    toDataURL(url, k, count, callback) {
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(url, tokenReNew).subscribe(res => {
                var xhr = new XMLHttpRequest()
                xhr.onload = function() {
                    var reader = new FileReader()
                    reader.onloadend = function() {
                        callback(reader.result)
                    }
                    reader.readAsDataURL(xhr.response)
                }
                xhr.open('GET', res['url'], true)
                xhr.responseType = 'blob'
                xhr.send()
            })
        })
    }

    // get redirected video url
    toVideoURL(url, callback) {
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(url, tokenReNew).subscribe(res => {
                callback(res['url'])
            })
        })
    }

    ngAfterViewInit(): void {

    }

    reRenderCanvas() {
        this.imgControl.canvas.renderAll()
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationDsd/modal-client-detail-registration-dsd.component.ts